export class BindLocationWithMultiplePlansJobRequest {
    planId! : string;
    locationId!: string;
    jobNumber!: string;
    jobId!: string;
    connectionId!: string;
    isCalculateETA!: boolean;
}